/* zocca · Story-Viewer der Produktseite („Míralo puesto“), Nachbau von La Pepa assets/lp-stories.js
 * Zeigt nur die Videos des einen Produkts (custom.videos) nacheinander, mit Fortschrittsbalken oben wie bei Instagram.
 * Tippen rechts = nächstes Video, links = vorheriges, Halten = Pause, nach unten wischen / X / Esc / Zurück = schließen.
 * Nach dem letzten Video schließt der Viewer.
 *
 * window.zoccaStories.open({ item, startVideoId, surface, trigger })
 *   item: Produkt-JSON aus snippets/video-historias-item-json.liquid (vd = Videos, v = Varianten)
 * Abweichung von La Pepa: Größenwahl im Viewer (Kleidung), kein PostHog. Add-to-cart per /cart/add.js mit
 * _origen: video-<surface> und _video: <id>; zocca-cart.js fängt den Aufruf ab und öffnet den Warenkorb,
 * deshalb schließt der Viewer nach dem Hinzufügen.
 */
const SOUND_KEY = 'sf-sound';
const SEEN_KEY = 'zocca-videos-vistos';
const SEEN_LIMIT = 200;
const QUALIFIED_MS = 3000;
const HOLD_MS = 220;
const PREV_ZONE = 0.3;

const read = (key, fallback) => { try { const v = JSON.parse(localStorage.getItem(key)); return v ?? fallback; } catch (e) { return fallback; } };
const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* privat */ } };
const canHls = () => Boolean(document.createElement('video').canPlayType('application/vnd.apple.mpegurl'));
const slowNetwork = () => { const c = navigator.connection; return Boolean(c?.saveData || /2g|3g/.test(c?.effectiveType || '')); };
const icon = (path) => `<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">${path}</svg>`;
const ICONS = {
  close: icon('<path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/>'),
  soundOff: icon('<path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="m16 9 5 6m0-6-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>'),
  soundOn: icon('<path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/>'),
};

const CSS = `
.lps{position:fixed;inset:0;z-index:2147483000;background:#000;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .18s ease;touch-action:none;-webkit-user-select:none;user-select:none}
.lps.is-open{opacity:1}
.lps__stage{position:relative;width:100%;height:100%;max-width:min(100vw,calc(100dvh * 9 / 16));background:#111;overflow:hidden}
@media (min-width:700px){.lps__stage{height:min(92dvh,900px);border-radius:16px}}
.lps__video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#111}
.lps__video[hidden]{display:none}
.lps__shade{position:absolute;inset:0;pointer-events:none;background:linear-gradient(to bottom,rgba(0,0,0,.45),transparent 22%,transparent 62%,rgba(0,0,0,.6))}
.lps__bars{position:absolute;top:10px;left:10px;right:10px;display:flex;gap:4px;z-index:2}
.lps__bar{flex:1;height:3px;border-radius:2px;background:rgba(255,255,255,.35);overflow:hidden}
.lps__bar span{display:block;height:100%;background:#fff;transform-origin:left;transform:scaleX(0)}
.lps__bar.is-done span{transform:scaleX(1)}
.lps__top{position:absolute;top:22px;left:12px;right:8px;display:flex;align-items:center;gap:8px;z-index:2;color:#fff}
.lps__title{flex:1;min-width:0;font-size:14px;font-weight:600;line-height:1.25;text-shadow:0 1px 2px rgba(0,0,0,.4);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.lps__icon{display:grid;place-items:center;width:40px;height:40px;padding:0;border:0;border-radius:50%;background:transparent;color:#fff;cursor:pointer}
.lps__icon:focus-visible,.lps__buy:focus-visible{outline:2px solid #fff;outline-offset:2px}
.lps__bottom{position:absolute;left:0;right:0;bottom:0;padding:14px 14px calc(14px + env(safe-area-inset-bottom));z-index:2;color:#fff}
.lps__sizes{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 12px}
.lps__size{min-width:44px;height:38px;padding:0 12px;border:1px solid rgba(255,255,255,.7);border-radius:999px;background:rgba(0,0,0,.35);color:#fff;font:inherit;font-size:14px;font-weight:600;cursor:pointer}
.lps__size[aria-pressed="true"]{background:#fff;color:#121111;border-color:#fff}
.lps__size[disabled]{opacity:.45;text-decoration:line-through;cursor:default}
.lps__size:focus-visible{outline:2px solid #fff;outline-offset:2px}
.lps__buy{position:relative;display:flex;width:100%;min-height:52px;align-items:center;justify-content:center;gap:8px;padding:0 18px;border:0;border-radius:999px;background:var(--zv-btn-bg,#121111);color:var(--zv-btn-text,#fff);font:inherit;font-size:16px;font-weight:700;cursor:pointer}
.lps__buy[disabled]{opacity:.6;cursor:default}
.lps__price{font-weight:600;opacity:.9}
.lps__spinner{position:absolute;top:50%;left:50%;width:34px;height:34px;margin:-17px 0 0 -17px;border:3px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:lps-spin .8s linear infinite;z-index:1;display:none}
.lps.is-waiting .lps__spinner{display:block}
@keyframes lps-spin{to{transform:rotate(360deg)}}
.lps__tap{position:absolute;top:70px;bottom:120px;left:0;right:0;z-index:1}
html.lps-locked,html.lps-locked body{overflow:hidden}
@media (prefers-reduced-motion:reduce){.lps{transition:none}}
`;

function injectStyle() {
  if (document.getElementById('zocca-stories-css')) return;
  const style = document.createElement('style');
  style.id = 'zocca-stories-css';
  style.textContent = CSS;
  document.head.append(style);
}

function selectedVariant(item) {
  // Variante, die auf der Produktseite gewählt ist, wenn verfügbar; sonst die erste verfügbare.
  for (const input of document.querySelectorAll('form[action*="/cart/add"] [name="id"]')) {
    const v = item.v.find((x) => String(x.id) === String(input.value));
    if (v?.av) return v;
  }
  return item.v.find((v) => v.av) || item.v[0];
}

class Stories {
  open({ item, startVideoId, surface = 'historias', trigger } = {}) {
    if (this.el || !item?.vd?.length) return;
    injectStyle();
    this.item = item;
    this.videos = item.vd;
    this.surface = surface;
    this.trigger = trigger || document.activeElement;
    this.index = Math.max(0, this.videos.findIndex((v) => String(v.id) === String(startVideoId)));
    this.muted = read(SOUND_KEY, false) !== true;
    this.stats = new Map();
    this.variant = selectedVariant(item);
    this.players = new Map();
    this.hls = canHls();
    this.slow = slowNetwork();
    this.build();
    this.show(this.index);
  }

  build() {
    const el = document.createElement('div');
    el.className = 'lps';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', this.item.t);
    el.innerHTML = `
      <div class="lps__stage">
        <div class="lps__shade"></div>
        <div class="lps__spinner" aria-hidden="true"></div>
        <div class="lps__bars">${this.videos.map(() => '<div class="lps__bar"><span></span></div>').join('')}</div>
        <div class="lps__top">
          <span class="lps__title"></span>
          <button type="button" class="lps__icon" data-lps-sound></button>
          <button type="button" class="lps__icon" data-lps-close aria-label="Cerrar">${ICONS.close}</button>
        </div>
        <div class="lps__tap" data-lps-tap></div>
        <div class="lps__bottom">
          <div class="lps__sizes" role="group" aria-label="Talla" data-lps-sizes hidden></div>
          <button type="button" class="lps__buy" data-lps-buy></button>
        </div>
      </div>`;
    el.querySelector('.lps__title').textContent = this.item.t;
    this.el = el;
    this.stage = el.querySelector('.lps__stage');
    this.bars = [...el.querySelectorAll('.lps__bar')];
    this.renderSound();
    this.renderSizes();
    this.renderBuy();

    el.querySelector('[data-lps-close]').addEventListener('click', () => this.close('close'));
    el.querySelector('[data-lps-sound]').addEventListener('click', () => this.toggleSound());
    el.querySelector('[data-lps-buy]').addEventListener('click', (e) => this.addToCart(e.currentTarget));
    this.bindGestures(el.querySelector('[data-lps-tap]'));

    this.onKey = (e) => {
      if (e.key === 'Escape') this.close('close');
      else if (e.key === 'ArrowRight') this.next();
      else if (e.key === 'ArrowLeft') this.prev();
    };
    this.onPop = () => this.close('back');
    this.onVisibility = () => (document.hidden ? this.pause() : this.resume());
    document.addEventListener('keydown', this.onKey);
    document.addEventListener('visibilitychange', this.onVisibility);
    window.addEventListener('popstate', this.onPop);
    history.pushState({ zoccaStories: true }, '');

    document.body.append(el);
    document.documentElement.classList.add('lps-locked');
    requestAnimationFrame(() => el.classList.add('is-open'));
    el.querySelector('[data-lps-close]').focus({ preventScroll: true });
  }

  bindGestures(zone) {
    let down = null;
    zone.addEventListener('pointerdown', (e) => {
      down = { x: e.clientX, y: e.clientY, t: Date.now(), held: false };
      down.timer = setTimeout(() => { if (down) { down.held = true; this.pause(); } }, HOLD_MS);
    });
    const end = (e, cancelled) => {
      if (!down) return;
      clearTimeout(down.timer);
      const dy = e.clientY - down.y;
      const dx = e.clientX - down.x;
      const held = down.held;
      down = null;
      if (held) { this.resume(); }
      if (cancelled) return;
      if (dy > 80 && Math.abs(dy) > Math.abs(dx)) { this.close('swipe_down'); return; }
      if (held || Math.abs(dx) > 30 || Math.abs(dy) > 30) return;
      const rect = this.stage.getBoundingClientRect();
      if (e.clientX - rect.left < rect.width * PREV_ZONE) this.prev(); else this.next();
    };
    zone.addEventListener('pointerup', (e) => end(e, false));
    zone.addEventListener('pointercancel', (e) => end(e, true));
    zone.addEventListener('contextmenu', (e) => e.preventDefault());
  }

  // HLS (cdn.shopify.com, siehe swipe-feed-item-json) wo nativ möglich, sonst mp4; lädt eine Quelle nicht, springt player() zur nächsten.
  sources(video) {
    return [...new Set([this.hls && video.hls, this.slow ? video.s4 : video.s7, video.s4, video.hls].filter(Boolean))];
  }

  player(i) {
    if (this.players.has(i)) return this.players.get(i);
    const video = this.videos[i];
    const el = document.createElement('video');
    el.className = 'lps__video';
    el.hidden = true;
    el.playsInline = true;
    el.setAttribute('playsinline', '');
    el.muted = true;
    el.preload = 'auto';
    el.poster = video.p;
    const sources = this.sources(video);
    let source = 0;
    el.src = sources[0];
    el.addEventListener('error', () => {
      if (!el.getAttribute('src') || ++source >= sources.length) return;
      el.src = sources[source];
      if (i === this.index && !this.paused) this.play(el);
    });
    el.addEventListener('ended', () => { if (i === this.index) this.next(true); });
    el.addEventListener('waiting', () => { if (i === this.index) this.el?.classList.add('is-waiting'); });
    el.addEventListener('playing', () => { if (i === this.index) this.el?.classList.remove('is-waiting'); });
    el.addEventListener('timeupdate', () => { if (i === this.index) this.onTime(i); });
    this.stage.insertBefore(el, this.stage.firstChild);
    const p = { el, video };
    this.players.set(i, p);
    return p;
  }

  release(i) {
    const p = this.players.get(i);
    if (!p) return;
    p.el.pause();
    p.el.removeAttribute('src');
    p.el.load();
    p.el.remove();
    this.players.delete(i);
  }

  show(i) {
    const prev = this.players.get(this.index);
    if (prev && this.index !== i) { prev.el.pause(); prev.el.hidden = true; }
    this.index = i;
    this.bars.forEach((bar, n) => {
      bar.classList.toggle('is-done', n < i);
      bar.querySelector('span').style.transform = n < i ? 'scaleX(1)' : 'scaleX(0)';
    });
    const p = this.player(i);
    p.el.hidden = false;
    p.el.muted = this.muted;
    try { p.el.currentTime = 0; } catch (e) { /* noch nicht geladen */ }
    this.view = { id: this.videos[i].id, last: 0 };
    this.el.classList.add('is-waiting');
    this.play(p.el);
    // nächstes Video vorladen, alles außer ±1 freigeben
    if (i + 1 < this.videos.length) this.player(i + 1);
    [...this.players.keys()].forEach((n) => { if (Math.abs(n - i) > 1) this.release(n); });
  }

  play(el) {
    const attempt = el.play();
    if (attempt?.catch) {
      attempt.catch(() => {
        // Autoplay mit Ton blockiert: stumm weiter
        if (!el.muted) { el.muted = true; this.muted = true; this.renderSound(); el.play().catch(() => {}); }
      });
    }
  }

  next(fromEnd = false) {
    if (this.index + 1 < this.videos.length) this.show(this.index + 1);
    else this.close(fromEnd ? 'ended' : 'tap_end');
  }

  prev() {
    if (this.index > 0) this.show(this.index - 1);
    else { const p = this.players.get(0); if (p) { p.el.currentTime = 0; this.play(p.el); } }
  }

  pause() { this.paused = true; this.players.get(this.index)?.el.pause(); }

  resume() {
    if (!this.el) return;
    this.paused = false;
    const p = this.players.get(this.index);
    if (p) this.play(p.el);
  }

  onTime(i) {
    const player = this.players.get(i);
    if (!player) return; // nach release() feuert noch ein timeupdate
    const { el } = player;
    const view = this.view;
    const duration = Number.isFinite(el.duration) && el.duration > 0 ? el.duration : this.videos[i].d / 1000;
    if (!duration || !view) return;
    this.bars[i].querySelector('span').style.transform = `scaleX(${Math.min(1, el.currentTime / duration)})`;
    const delta = el.currentTime - view.last;
    view.last = el.currentTime;
    const stats = this.statsFor(view.id);
    if (delta > 0 && delta < 1.5) {
      stats.watchMs += delta * 1000;
      if (!stats.qualified && stats.watchMs >= QUALIFIED_MS) {
        stats.qualified = true;
        this.rememberSeen(view.id);
      }
    }
  }

  statsFor(id) {
    if (!this.stats.has(id)) this.stats.set(id, { watchMs: 0, qualified: false });
    return this.stats.get(id);
  }

  rememberSeen(id) {
    const seen = read(SEEN_KEY, []).map(String).filter((x) => x !== String(id));
    seen.push(String(id));
    write(SEEN_KEY, seen.slice(-SEEN_LIMIT));
    document.querySelectorAll(`[data-video-id="${id}"]`).forEach((b) => b.classList.add('is-seen'));
  }

  toggleSound() {
    this.muted = !this.muted;
    write(SOUND_KEY, !this.muted);
    const p = this.players.get(this.index);
    if (p) { p.el.muted = this.muted; if (!this.muted) this.play(p.el); }
    this.renderSound();
  }

  renderSound() {
    const btn = this.el.querySelector('[data-lps-sound]');
    btn.innerHTML = this.muted ? ICONS.soundOff : ICONS.soundOn;
    btn.setAttribute('aria-label', this.muted ? 'Activar sonido' : 'Silenciar');
  }

  // Größen-Chips nur bei mehreren Varianten; ausverkaufte durchgestrichen und deaktiviert
  renderSizes() {
    const box = this.el.querySelector('[data-lps-sizes]');
    if (this.item.v.length < 2) return;
    box.hidden = false;
    for (const v of this.item.v) {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'lps__size';
      chip.textContent = v.t;
      chip.disabled = !v.av;
      chip.setAttribute('aria-pressed', String(v.id === this.variant?.id));
      if (!v.av) chip.setAttribute('aria-label', `${v.t}, agotado`);
      chip.addEventListener('click', () => {
        this.variant = v;
        box.querySelectorAll('.lps__size').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
        this.renderBuy();
      });
      box.append(chip);
    }
  }

  renderBuy(message) {
    const btn = this.el.querySelector('[data-lps-buy]');
    const variant = this.variant;
    btn.disabled = !variant?.av;
    btn.innerHTML = '';
    const label = document.createElement('span');
    const sized = this.item.v.length > 1;
    label.textContent = message || (!variant?.av ? 'Agotado' : sized ? `Añadir talla ${variant.t}` : 'Añadir al carrito');
    btn.append(label);
    if (!message && variant?.av && variant.p) {
      const price = document.createElement('span');
      price.className = 'lps__price';
      price.textContent = `· ${variant.p}`;
      btn.append(price);
    }
  }

  async addToCart(button) {
    const variant = this.variant;
    if (!variant?.av || button.getAttribute('aria-busy') === 'true') return;
    const video = this.videos[this.index];
    button.setAttribute('aria-busy', 'true');
    try {
      // Einzelnes Item (nicht items[]): zocca-cart.js liest product_id aus der Antwort für „Completa tu look“
      const res = await fetch(`${(window.Shopify && Shopify.routes && Shopify.routes.root) || '/'}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1, properties: { _origen: `video-${this.surface}`, _video: String(video.id) } }) });
      if (!res.ok) throw new Error(String(res.status));
      button.removeAttribute('aria-busy');
      this.close('added');
    } catch (e) {
      button.removeAttribute('aria-busy');
      this.renderBuy(e.message === '422' ? 'Sin stock en esta talla' : 'No pudimos agregarlo');
      setTimeout(() => { if (this.el) this.renderBuy(); }, 3000);
    }
  }

  close(reason) {
    if (!this.el) return;
    const el = this.el;
    this.el = null;
    document.removeEventListener('keydown', this.onKey);
    document.removeEventListener('visibilitychange', this.onVisibility);
    window.removeEventListener('popstate', this.onPop);
    if (reason !== 'back' && history.state?.zoccaStories) history.back();
    [...this.players.keys()].forEach((n) => this.release(n));
    el.classList.remove('is-open');
    document.documentElement.classList.remove('lps-locked');
    setTimeout(() => el.remove(), 200);
    this.trigger?.focus?.({ preventScroll: true });
  }
}

window.zoccaStories = window.zoccaStories || new Stories();
